import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '@/shared/components/ui/empty'
import { Spinner } from '@/shared/components/ui/spinner'

export const PendingContent = () => {
	const { t } = useTranslation()

	return (
		<Empty>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<Spinner className='text-muted-foreground' />
				</EmptyMedia>
				<EmptyTitle>
					{t('bulk_modal_bulk_update_pending', {
						defaultValue: 'Updating products...',
					})}
				</EmptyTitle>
				<EmptyDescription>
					{t('bulk_modal_bulk_update_pending_description', {
						defaultValue:
							'This may take a few minutes. Please wait for the process to complete.',
					})}
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
